import { Select, Alert } from '@piggytechng/component-library';
import SideSheet from '..';
import { OverideSelectStyle } from '../../../helpers/utils';
import { RepushWebhookSheetProps } from '../../../types';
import './RepushWebhookSheet.scss';
import { useEffect, useState } from 'react';
import useWebhooks from '../../../hooks/useWebhooks';

const RepushWebhookSheet = ({ onClose = () => {}, show, which }: RepushWebhookSheetProps) => {
  const { isLoading, repushWebhooks } = useWebhooks();

  const close = () => {
    onClose();
  };

  const [form, setForm] = useState({
    reference: '',
    Provider: '',
  });

  const providers = [
    { label: 'FAAS', value: ' faas' },
    { label: 'VFD', value: 'vfd' },
    { label: 'Squad', value: 'squad' },
  ];

  useEffect(() => {
    setForm({
      reference: '',
      Provider: '',
    });
  }, [show]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (which === 'p2p') {
      if (!form.reference) {
        return Alert.error('Session ID is required');
      }
      await repushWebhooks(form.reference, () => {
        close();
      });
    } else {
      // Alert.info('Repush Transfer Webhook not implemented yet');
    }
  };

  return (
    <div>
      <SideSheet
        onClose={close}
        active={show}
        title={which === 'transfer' ? 'Repush Transfer Webhook' : 'Repush P2P Webhook'}
      >
        <div className="repush-webhook-sheet-p2p flex--4">
          <form className="flex--4" onSubmit={handleSubmit}>
            {which === 'transfer' && (
              <Select
                {...OverideSelectStyle}
                labelStyle={{ color: '#666766' }}
                label="Provider"
                placeholder="Select provider"
                options={providers}
                value={form.Provider}
                onChange={(e) => setForm({ ...form, Provider: e })}
              />
            )}

            <input
              onChange={(e) => setForm({ ...form, reference: e.target.value })}
              type="text"
              placeholder={which === 'p2p' ? 'Session ID' : 'Reference'}
              className="input"
              value={form.reference}
            />

            <button disabled={isLoading.repushWebhooks} type="submit" id="confirm-password-btn">
              {isLoading.repushWebhooks ? 'Processing...' : 'Repush'}
            </button>
          </form>
        </div>
      </SideSheet>
    </div>
  );
};

export default RepushWebhookSheet;
